import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './movementsInbound.html'

/**
 * Inbound type of Movements Report route
 *
 * @namespace routes.ReportMovementsInbound
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.movementsInbound.list',
  label: 'REPORT.MOVEMENTS.TITLEINBOUND',
  url: '/movements/inbound',
  component: 'tmrReportMovementsInbound',
  mainMenu: false,
  resourceType: 'MovementInbound',
  resourceList: {
    searchParameters: [
      'creationDate.from',
      'creationDate.to',
      'user.id',
      'originPlace.id',
      'originPlace.placeType',
      'destinationPlace.id',
      'destinationPlace.placeType',
      'inboundParcel.id',
      'inboundParcel.asn.id',
      'inboundZone.id',
    ],
  },
  resolve: {
    movementTypes: /*@ngInject*/ tmrMovementTypes => tmrMovementTypes,
    placeTypes: /*@ngInject*/ tmrPlaceTypes => tmrPlaceTypes,
    zoneTypes: /*@ngInject*/ tmrZoneTypes => tmrZoneTypes,
  },
  accessControl: 'TmrShippingOperationsLegacyAccessControl',
  data: {
    capabilities: ['Resource.list', 'Resource.MovementInbound.list'],
  },
}

/**
 * Component for {@link routes.tmrReportMovementsInbound Movements Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportMovementsInbound = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings({
    movementTypes: '<',
    placeTypes: '<',
    zoneTypes: '<',
  }),
}
